export default {
  settingsAdminTitle: "SETTINGS_ADMIN_TITLE"
}



// WEBPACK FOOTER //
// ./src/locales/settings-admin/index.ts